import { useEffect } from "react";
import { observer } from "mobx-react-lite";
import { Spinner } from "@/components/Spinner";
import { DialogTitle } from "@/components/ui/dialog";
import { useGetNoteFile } from "../useGetNoteFile";

type NoteFilePreviewProps = {
	noteId: Dryp.NoteId;
};

const NoteFilePreviewComponent = observer(({ noteId }: NoteFilePreviewProps) => {
	const { fetchNoteFile, fileUrl, loading } = useGetNoteFile(noteId);

	useEffect(() => {
		fetchNoteFile();
	}, [noteId]);

	return (
		<>
			<DialogTitle className="sr-only">Document preview</DialogTitle>
			{loading || !fileUrl ? (
				<div className="flex h-full items-center justify-center">
					<Spinner messages={[]} size={48} />
				</div>
			) : (
				<iframe src={fileUrl} title="Document preview" className="w-full h-full" />
			)}
		</>
	);
});

export const NoteFilePreview = Object.assign(NoteFilePreviewComponent, {
	dialogClassName: "w-[90vw] max-w-4xl h-[90vh] p-0",
	closeButtonOutside: true,
});
